import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";

const CATEGORIES = ["All", "Accessories", "Clothing", "Bags"];

export default function ProductsPage() {
  const [products, setProducts] = useState([]);
  const [params, setParams] = useSearchParams();
  const category = params.get("category") || "All";
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const qs = category && category !== "All" ? `?category=${encodeURIComponent(category)}` : "";
    api.get(`/products${qs}`).then((r) => setProducts(r.data)).finally(() => setLoading(false));
  }, [category]);

  return (
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24" data-testid="shop-page">
      <p className="label-eyebrow mb-3">Shop</p>
      <h1 className="font-serif text-5xl md:text-6xl tracking-tighter mb-12">
        {category === "All" ? "All products" : category}
      </h1>

      <div className="flex flex-wrap gap-3 mb-12" data-testid="category-filters">
        {CATEGORIES.map((c) => (
          <button
            key={c}
            onClick={() => setParams(c === "All" ? {} : { category: c })}
            data-testid={`category-filter-${c}`}
            className={`px-5 py-2.5 text-xs tracking-[0.2em] uppercase border transition-all ${
              category === c ? "bg-[#333E48] text-white border-[#333E48]" : "bg-transparent text-[#333E48] border-[#E8E2D9] hover:border-[#333E48]"
            }`}
          >
            {c}
          </button>
        ))}
      </div>

      {loading ? (
        <p className="text-[#6A747D]">Loading…</p>
      ) : products.length === 0 ? (
        <p className="text-[#6A747D]">No products found.</p>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-8 gap-y-12" data-testid="shop-grid">
          {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
